import { render, staticRenderFns } from "./print-yaoqiu-table.vue?vue&type=template&id=54bffdb2&scoped=true"
import script from "./print-yaoqiu-table.vue?vue&type=script&lang=js"
export * from "./print-yaoqiu-table.vue?vue&type=script&lang=js"
import style0 from "./print-yaoqiu-table.vue?vue&type=style&index=0&id=54bffdb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bffdb2",
  null
  
)

export default component.exports